module.exports = __webpack_public_path__ + "img/home_tier_bronze_new_theme.svg";